import React, { useEffect } from 'react'
import UserConfigSection from "Pages/Admin/Users/CreateDrawer/Content/Config"
import UserSitesOfficesContent from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices"
import UserInfoSection from "Pages/Admin/Users/CreateDrawer/Content/UserInfo"
import ConfirmSaveModal from "Pages/Admin/Users/CreateDrawer/Content/ConfirmSaveModal"
import { useCreateUsersModal } from "Pages/Admin/Users/@hooks"
import { editUserId } from "Pages/Admin/Users/@signals"

export default function CreateUserDrawerContent() {
	const { onEditUser, userId, isEditLoading } = useCreateUsersModal()


	useEffect(() => {
		if (editUserId.value) {
			onEditUser()
		}
	}, [userId])


	return <>
		<UserInfoSection isLoading={isEditLoading}/>
		<UserSitesOfficesContent isLoading={isEditLoading}/>
		<UserConfigSection isLoading={isEditLoading}/>
		<ConfirmSaveModal/>
	</>
}